import {
  Box,
  Button,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormControlLabel,
  Checkbox,
  Skeleton,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { rem, maxLen } from "assets/js/common";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import AlertConfirm from "components/ui/alert-confirm";
import AlertComplete from "components/ui/alert-complete";
import { useHistory } from "react-router-dom";

export default function ShoppingMemoList(props) {
  const dispatch = useDispatch();
  const { init } = useSelector((state) => state.top);
  const [shoppingMemoList, setShoppingMemoList] = useState([]);
  const [open, setOpen] = useState(false);
  const [alertMode, setAlertMode] = useState("");
  const [delItem, setDelItem] = useState("");
  const [delArr, setDelArr] = useState([]);
  const history = useHistory();

  const handleAlertMode = (mode, item) => {
    setAlertMode(mode);
    setOpen(true);
    setDelItem(item);
  };

  const handleAlertClose = () => {
    setOpen(false);
  };

  const [memo, setMemo] = useState("");

  const fetchData = async () => {
    await axios.get("/api/mb/shopping-memo").then((res) => {
      setShoppingMemoList(res.data.data.shoppingMemoList);
    });
  };

  const onDelete = () => {
    console.log("delItem", delItem);
    axios
      .post("/api/mb/shopping-memo/remove", null, {
        params: {
          seq: delItem.seq,
        },
      })
      .then((res) => {
        setOpen(false);
        fetchData();
      });
  };

  const onSelectDelete = (seq) => {
    axios.post("/api/mb/shopping-memo/remove-list", delArr).then((res) => {
      setOpen(false);
      setDelArr([]);
      fetchData();
    });
  };

  const onAllDelete = () => {
    axios.post("/api/mb/shopping-memo/remove-all").then((res) => {
      setOpen(false);
      fetchData();
    });
  };

  const onRegist = () => {
    if (!memo) return;

    axios
      .post("/api/mb/shopping-memo/regist", {
        memo: memo,
      })
      .then((res) => {
        if (res.data.data) {
          setMemo("");
          setDelArr([]);
          fetchData();
        }
      });
  };

  const handleChangeCheckbox = (event) => {
    const target = event.target;

    let arr = [...delArr];

    if (target.checked) {
      arr.push(Number(target.value));
    } else {
      _.remove(arr, (item) => item == target.value);
    }

    setDelArr(arr);

    console.log("arr", arr);
  };

  const handleValueCounter = (e) => {
    let value = maxLen(e.target.value, 10);
    setMemo(value);
  };

  const callback = () => {
    handleAlertClose(false);
    fetchData();
  };

  window.appBackKeyHandle = () => {
    if (open) {
      setOpen(false);
    } else {
      history.goBack();
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "쇼핑메모", menu: true }));
  }, [init]);

  return (
    <>
      <div className="regist-shopping">
        <FormControl variant="outlined">
          <OutlinedInput
            type="text"
            inputProps={{ maxLength: 10 }}
            value={memo}
            onInput={handleValueCounter}
            placeholder="장볼 상품 입력 후 등록을 눌러주세요"
            endAdornment={
              <InputAdornment position="end">
                <span className="count">{memo.length}/10</span>
                <Button
                  aria-label="registration"
                  type="button"
                  edge="end"
                  onClick={onRegist}
                >
                  등록
                </Button>
              </InputAdornment>
            }
          />
        </FormControl>
        {shoppingMemoList.map((item, i) => (
          <ul className="shopping-list" key={`shopping${i}`}>
            <li>
              <FormControlLabel
                value={item.seq}
                control={
                  <Checkbox
                    color="primary"
                    icon={<span className="checkbox-icon" />}
                    checkedIcon={<span className="checkbox-icon-checked" />}
                    onChange={(e) => {
                      handleChangeCheckbox(e, item.seq);
                    }}
                    checked={delArr.includes(Number(item.seq))}
                  />
                }
                label={item.memo}
              />
              <IconButton
                aria-label="delete"
                onClick={() => handleAlertMode("onDelConfirm", item)}
              >
                <i className="ico-del" />
              </IconButton>
            </li>
          </ul>
        ))}
        {shoppingMemoList.length > 0 && (
          <div className="btns-text">
            <Button
              color="info"
              onClick={() => {
                console.log("delArr.length", delArr.length);
                if (delArr.length == 0) {
                  handleAlertMode("onSelDelComplete");
                } else {
                  handleAlertMode("onSelDelConfirm");
                }
              }}
            >
              선택삭제
            </Button>
            <Button
              color="info"
              onClick={() => handleAlertMode("onAllDelConfirm")}
            >
              전체삭제
            </Button>
          </div>
        )}
      </div>

      {alertMode == "onDelConfirm" ? (
        <AlertConfirm
          open={open}
          handleAlertClose={handleAlertClose}
          text={`${delItem.memo}을(를) 삭제하시겠습니까?`}
          action={onDelete}
          callback={callback}
        />
      ) : alertMode == "onSelDelConfirm" ? (
        <AlertConfirm
          open={open}
          handleAlertClose={handleAlertClose}
          text="선택된 메모를 삭제하시겠습니까? "
          action={onSelectDelete}
          callback={callback}
        />
      ) : alertMode == "onAllDelConfirm" ? (
        <AlertConfirm
          open={open}
          handleAlertClose={handleAlertClose}
          text="입력된 모든 메모를 삭제하시겠습니까?"
          action={onAllDelete}
          callback={callback}
        />
      ) : (
        <AlertComplete
          open={open}
          handleAlertClose={handleAlertClose}
          text="선택된 메모가 없습니다."
          action={handleAlertClose}
        />
      )}
    </>
  );
}
